import { useEffect } from "react";

export function useCloseOnEscape(close: () => void, keyboardEventDisabled?: boolean): void {
	useEffect(() => {
		const closeModal = (e: KeyboardEvent): void => {
			if (!keyboardEventDisabled && e.key === "Escape") {
				close();
			}
		};
		window.addEventListener("keydown", closeModal);
		return () => window.removeEventListener("keydown", closeModal);
	}, []);
}
